import { Types } from "../actions/breakDownDetailActions";

const initialState = {
    taskDetail: {},
    taskEkedList: {},
    sameLevelList: [],
    rootCauses: {},
    bdPoolList: [],
    bdReasonList: [],
    bdReasonGroupList: [],
    bdEffectList: [],
    actionRes: {},
    unplannedMaintenaceOfTheReports: {},
    updateReportList: false,
    setListByStatusUnPM: {},
    setListUnPMReportsByStatus: {},
    reasonPlaces: {},
    setBDReasonDetailList: {},
    unplannedFiles: null,

    taskHistory: {},
    maintenancePauseReasons: [],
    technicians: undefined,

    isTaskUpdated: false,
    isDeletedReports: false,

    activeUsersTaskId: {},
};

export const breakDownDetailReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_TASK_DETAIL_BY_ID:
            return {
                ...state,
                taskDetail: action.payload,
            };
        case Types.SET_SAME_LEVEL_LIST_BY_ID:
            return {
                ...state,
                sameLevelList: action.payload || state.sameLevelList,
            };
        case Types.SET_BREAK_DOWN_ROOT_CAUSE_LIST:
            return {
                ...state,
                taskDetail: {},
                sameLevelList: [],
                rootCauses: action.payload || state.rootCauses,
            };
        case Types.SET_BD_POOL_LIST:
            return {
                ...state,
                bdPoolList: action.payload || state.bdPoolList,
            };
        case Types.SET_BREAK_DOWN_REASON_LIST:
            return {
                ...state,
                bdReasonList: action.payload || state.bdReasonList,
            };
        case Types.SET_BREAK_DOWN_EFFECT_LIST:
            return {
                ...state,
                bdEffectList: action.payload || state.bdEffectList,
            };
        case Types.CREATE_SUBTASK_UNPLANNED_MAINTENANCE_SUCCESS:
            return {
                ...state,
                subtaskUnPM: action.payload || state.subtaskUnPM,
            };
        case Types.SET_UNPLANNED_MAINTENANCE_OF_THE_REPORT:
            return {
                ...state,
                unplannedMaintenaceOfTheReports: action.payload || state.unplannedMaintenaceOfTheReports,
            };
        case Types.UPDATE_REPORT_LIST:
            return {
                ...state,
                updateReportList: true,
            };
        case Types.RESET_UPDATE_REPORT_LIST:
            return {
                ...state,
                updateReportList: false,
            };
        case Types.SETLIST_BYSTATUS_UNPLANNED_MAINTENANCE:
            return {
                ...state,
                setListByStatusUnPM: action.payload || state.setListByStatusUnPM,
            };
        case Types.SET_UNPLANNED_MAINTENANCE_OF_THE_REPORT_WITH_STATUS:
            return {
                ...state,
                setListUnPMReportsByStatus: action.payload || state.setListUnPMReportsByStatus,
            };
        case Types.SET_BDREASON_PLACELIST_BYGROUPID:
            return {
                ...state,
                reasonPlaces: action.payload || state.reasonPlaces,
            };
        case Types.SET_BDREASON_DETAILLIST_BYPLACEID:
            return {
                ...state,
                setBDReasonDetailList: action.payload || state.setBDReasonDetailList,
            };
        case Types.IS_UPDATED_TASK:
            return {
                ...state,
                isTaskUpdated: true,
            };
        case Types.RESET_IS_UPDATED_TASK:
            return {
                ...state,
                isTaskUpdated: false,
            };
        case Types.IS_DELETED_REPORTS:
            return {
                ...state,
                isDeletedReports: true,
            };
        case Types.RESET_IS_DELETED_REPORTS:
            return {
                ...state,
                isDeletedReports: false,
            };
        case Types.SET_UNPLANNED_FILES:
            return {
                ...state,
                unplannedFiles: action.payload || state.unplannedFiles,
            };

        case Types.SET_TASKHISTORY_BY_ID_UNPLANNED_MAINTENANCE:
            return {
                ...state,
                taskHistory: action.payload || state.taskHistory,
            };
        case Types.SET_MAINTENANCE_PAUSE_REASON_LIST:
            return {
                ...state,
                maintenancePauseReasons: action.payload || state.maintenancePauseReasons,
            };
        case Types.SET_TECH_LIST_FOR_BREAK_DOWN_DETAIL:
            return {
                ...state,
                technicians: action.payload || state.technicians,
            };
        case Types.SET_ACTION_REPONSE:
            return {
                ...state,
                actionRes: action.payload || state.actionRes,
            };
        case Types.SET_BREAK_DOWN_REASON_R_POOL_LIST:
            return {
                ...state,
                bdReasonGroupList: action.payload || state.bdReasonGroupList
            };
        case Types.RESET_ACTION_REPONSE:
            return {
                ...state,
                actionRes: {},
            };

        case Types.RESET_TECHNICIANS:
            return {
                ...state,
                technicians: undefined,
            };
        case Types.RESET_ROOT_CAUSES:
            return {
                ...state,
                rootCauses: {},
            };
        case Types.RESET_LIST_BYSTATUS_UNPLANNED_MAINTENANCE:
            return {
                ...state,
                setListByStatusUnPM: {},
            };
        case Types.RESET_BREAK_DOWN_REASON_LIST:
            return {
                ...state,
                bdReasonList: undefined,
            };
        case Types.RESET_BDREASON_PLACELIST_BYGROUPID:
            return {
                ...state,
                reasonPlaces: {},
            };
        case Types.RESET_BDREASON_DETAILLIST_BYPLACEID:
            return {
                ...state,
                setBDReasonDetailList: undefined,
            };
        case Types.RESET_MAINTENANCE_PAUSE_REASON_LIST:
            return {
                ...state,
                maintenancePauseReasons: undefined,
            };
        case Types.RESET_TASKHISTORY_BY_ID_UNPLANNED_MAINTENANCE:
            return {
                ...state,
                taskHistory: {},
            };
        case Types.RESET_UNPLANNED_FILES:
            return {
                ...state,
                unplannedFiles: {},
            };
        case Types.RESET_BD_POOL_LIST:
            return {
                ...state,
                bdPoolList: undefined,
            };
        case Types.RESET_BREAK_DOWN_EFFECT_LIST:
            return {
                ...state,
                bdEffectList: undefined,
            };
        case Types.RESET_SAME_LEVEL_LIST_BY_ID:
            return {
                ...state,
                sameLevelList: undefined,
            };
        case Types.RESET_CREATE_SUBTASK_UNPLANNED_MAINTENANCE_SUCCESS:
            return {
                ...state,
                subtaskUnPM: undefined,
            };
        case Types.RESET_TASK_DETAIL_BY_ID:
            return {
                ...state,
                taskDetail: undefined,
            };
        case Types.SET_EKED_EQUIPMENT_LIST_UNPLANNED:
            return {
                ...state,
                taskEkedList: action.payload || state.taskEkedList,
            };
        case Types.SET_CURRENT_USERS_ACTIVE_TASK_ID:
            return {
                activeUsersTaskId: action.payload || state.activeUsersTaskId,
            };
        default:
            return state;
    }
};
